import { ProgressBar } from '@lessonup/ui-components';
import React, { useEffect } from 'react';
import { useUploadStatusPolling } from '../../hooks/useUploadStatusPolling';
import { useUploadsStatus } from '../../hooks/useUploadsStatus';

interface UploadProgressProps {
  uploadId: string;
  onCompleted: () => void;
  onError: (error: Error) => void;
}

export const UploadProgress: React.FC<UploadProgressProps> = ({ uploadId, onCompleted, onError }) => {
  const { startPollingForIds } = useUploadStatusPolling({ onError });
  const { data } = useUploadsStatus({
    ids: [uploadId],
    onAllCompleted: onCompleted,
    onQueryDocumentError: onError,
  });

  useEffect(() => {
    startPollingForIds([uploadId]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ProgressBar value={data?.viewer.uploadsByIds[0].progressPercentage || 0} />;
};
